// src/store/context/ProductContext.js
import React, { createContext, useCallback, useContext, useState } from "react";
import { useNotification } from "../notification-context";
import { postAuthenticatedRequest } from "../../../utils/api/requests/request";

// Create context
const ProductContext = createContext();

// Custom hook to use the Product context
export const useProductContext = () => useContext(ProductContext);

export const ProductConfigurationProvider = ({ children }) => {
  const { triggerNotification } = useNotification();
  const [configuredLoanProducts, setConfiguredLoanProducts] = useState(null);
  const [configuredSavingsProducts, setConfiguredSavingsProducts] =
    useState(null);
  const [isLoanProductsLoading, setIsLoanProductsLoading] = useState(false);
  const [isSavingsProductLoading, setIsSavingsProductLoading] = useState(false);

  const getConfiguredLoanProducts = async () => {
    try {
      setIsLoanProductsLoading(true);
      const response = await postAuthenticatedRequest(
        "GetSelfServiceLoanProductsQuery"
      );

      const result = response?.outData;
      if (result?.isSuccessful) {
        const transformedData = result?.data.map((product) => ({
          id: product?.id,
          name: product?.name,
          code: product?.code,
          currencyCode: product?.currencyCode,
          interestRateCalculation: product?.interestRateCalculationPeriod,
          interestRateCalculationDescription:
            product?.interestRateCalculationDescription,
          interestRate: product?.interestRate,
          disbursementFeeCalculation: product?.disbursementFeeCalculation,
          disbursementFeeCalculationDescription:
            product?.disbursementFeeCalculationDescription,
          disbursementFee: product?.disbursementFee,
          minimumAmount: product?.minimumAmount,
          maximumAmount: product?.maximumAmount,
          maximumTenorInDays: product?.maximumTenorInDays,
        }));
        setConfiguredLoanProducts(transformedData);
      } else {
        triggerNotification({
          type: "error",
          message: "Error",
          description: result?.message,
        });
      }
    } catch (error) {
      triggerNotification({
        type: "error",
        message: "Error",
        description: error?.message || "Failed to fetch user data",
      });
    } finally {
      setIsLoanProductsLoading(false);
    }
  };
  const getConfiguredSavingsProducts = async () => {
    try {
      setIsSavingsProductLoading(true);
      const response = await postAuthenticatedRequest(
        "GetSavingsPlanTypeQuery"
      );

      const result = response?.outData;

      console.log("savings plan are ", result);
      if (result?.isSuccessful) {
        setConfiguredSavingsProducts(result?.data?.plans);
      } else {
        triggerNotification({
          type: "error",
          message: "Error",
          description: result?.message,
        });
      }
    } catch (error) {
      triggerNotification({
        type: "error",
        message: "Error",
        description: error?.message || "Failed to fetch user data",
      });
    } finally {
      setIsSavingsProductLoading(false);
    }
  };

  return (
    <ProductContext.Provider
      value={{
        configuredLoanProducts,
        configuredSavingsProducts,
        isLoanProductsLoading,
        isSavingsProductLoading,
        getConfiguredLoanProducts,
        getConfiguredSavingsProducts,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
